import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import s from '../styles/AddVehicles.module.css'; 
import UploadExcel from "./UploadExcel";

const AddVehicle = () => {
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vin, setVin] = useState("");
  const [mileage, setMileage] = useState("");
  const [dateAcceptance, setDateAcceptance] = useState("");
  const [color, setColor] = useState("");
//   const [vehicleStatus, setVehicleStatus] = useState("В процессе");
  
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [filteredVehicleTypes, setFilteredVehicleTypes] = useState([]);
  
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);


  const [showBrandDropdown, setShowBrandDropdown] = useState(false); // Флаг для показа списка
  const [showModelDropdown, setShowModelDropdown] = useState(false); 
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);


  const isFormValid = brand && model && vehicleType && vin && mileage && color;



  // 📌 Загружаем марки при монтировании
  useEffect(() => {
    fetch("/api/vehicle/brands")
      .then((res) => res.json())
      .then((data) => setBrands(data))
      .catch(() => setError("Ошибка загрузки марок"));
  }, []);

   // 📌 Загружаем модели при изменении бренда (и сразу отображаем первые 5)
   useEffect(() => {
    if (brand) {
      fetch(`/api/vehicle/models?brand=${brand}`)
        .then((res) => res.json())
        .then((data) => {
          setModels(data);
          setFilteredModels(data.slice(0, 10)); // Показываем первые 5
          setShowModelDropdown(true); // Открываем выпадающий список
        })
        .catch(() => setError("Ошибка загрузки моделей"));
    } else {
      setModels([]);
      setFilteredModels([]);
      setShowModelDropdown(false);
    }
  }, [brand]);

    // 📌 Загружаем типы при изменении модели (и сразу показываем первые 5)
    useEffect(() => {
        if (model) {
          fetch(`/api/vehicle/types?model=${model}`)
            .then((res) => res.json())
            .then((data) => {
              setVehicleTypes(data);
              setFilteredVehicleTypes(data.slice(0, 10)); // Показываем первые 5
              setShowTypeDropdown(true); // Открываем список
            })
            .catch(() => setError("Ошибка загрузки типов ТС"));
        } else {
          setVehicleTypes([]);
          setFilteredVehicleTypes([]);
          setShowTypeDropdown(false);
        }
      }, [model]);

  // 📌 Фильтрация марок
  const handleBrandChange = (value) => {
    setBrand(value);
    if (value.length === 0) {
      setShowBrandDropdown(false); // Если поле очистили, скрываем список
    } else {
      setShowBrandDropdown(true);
      setFilteredBrands(
        brands.filter((b) => b.toLowerCase().includes(value.toLowerCase())).slice(0, 10)
      );
    }
  };

  // 📌 Выбор марки
  const selectBrand = (selectedBrand) => {
    setBrand(selectedBrand);
    setShowBrandDropdown(false); // Скрываем список после выбора
    setModel(""); // Сбрасываем модель при смене бренда
    setVehicleType(""); // Сбрасываем тип ТС
  };



   // 📌 Фильтрация model
   const handleModelChange = (value) => {
    setModel(value);
    setShowModelDropdown(value.length > 0);
    setFilteredModels(
      models.filter((m) => m.toLowerCase().includes(value.toLowerCase())).slice(0, 10)
    );
  };

  const selectModel = (selectedModel) => {
    setModel(selectedModel);
    setShowModelDropdown(false);
    setVehicleType(""); // Сбрасываем тип ТС при смене модели
  };




  // 📌 Фильтрация типов ТС
  const handleVehicleTypeChange = (value) => {
    setVehicleType(value);
    setShowTypeDropdown(value.length > 0);
    setFilteredVehicleTypes(
      vehicleTypes.filter((t) => t.toLowerCase().includes(value.toLowerCase())).slice(0, 10)
    );
  };

  const selectVehicleType = (selectedType) => {
    setVehicleType(selectedType);
    setShowTypeDropdown(false);
  };

  // 📌 Функция скрытия выпадающего списка при потере фокуса
  const handleBlur = (setDropdown) => {
    setTimeout(() => setDropdown(false), 200); // Задержка для обработки клика
  };


  // 📌 Отправка данных на сервер
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Проверка, заполнены ли все поля
    if (!brand || !model || !vehicleType || !vin || !mileage || !color) {
        setError("Заполните все поля!");
        return;
    }
    const newVehicle = { brand, model, vehicle_type: vehicleType, vin, mileage, color, date_acceptance: dateAcceptance };

    try {
      const response = await fetch("/api/vehicle/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newVehicle),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Ошибка при добавлении");

      setMessage("Автомобиль добавлен!");
      setError(null);
      setBrand("");
      setModel("");
      setVehicleType("");
      setVin("");
      setMileage("");
      setColor("");
      setDateAcceptance("");
    } catch (err) {
      setError(err.message);
      setMessage(null);
    }
  };

  const handleVinChange = (e) => {
    setVin(e.target.value.toUpperCase());
  };
  


  return (
    <div className={s.container}>
      <p className={s.head_p}>Добавить автомобиль</p>
      <div className={s.lable_section_div}>
      </div>
      <div>
        <UploadExcel />
      </div>

      <div className={s.lable_section_div}>
      </div>

      <form onSubmit={handleSubmit} className={s.form}>

        <div className={s.input_edit_wrapper}>
          <label className={s.label_add}>VIN</label>
          <input className={s.input_add} type="text" value={vin} onChange={handleVinChange} required />
        </div>
      
        {/* Марка */}

        <div className={s.input_edit_wrapper}>
        <label className={s.label_add}>Марка</label>
        <input
          className={s.input_add}
          type="text"
          value={brand}
          onChange={(e) => handleBrandChange(e.target.value)}
          onBlur={() => handleBlur(setShowBrandDropdown)}
          required
        />
        {showBrandDropdown && (
          <div className={s.dropdown}>
            {filteredBrands.map((b) => (
              <p key={b} className={s.dropdownItem} onClick={() => selectBrand(b)}>
                {b}
              </p>
            ))}
          </div>
        )}
        </div>

         {/* Модель */}
         <div className={s.input_edit_wrapper}>
         <label className={s.label_add}>Модель</label>
        <input
          className={s.input_add}
          type="text"
          value={model}
          onChange={(e) => handleModelChange(e.target.value)}
          onBlur={() => handleBlur(setShowModelDropdown)}
          required
        />
        {showModelDropdown && (
          <div className={s.dropdown}>
            {filteredModels.map((t) => (
              <p key={t} className={s.dropdownItem} onClick={() => selectModel(t)}>
                {t}
              </p>
            ))}
          </div>
        )}
        </div>

        {/* Тип ТС */}
        <div className={s.input_edit_wrapper}>
        <label className={s.label_add}>Тип ТС</label>
        <input
          className={s.input_add}
          type="text"
          value={vehicleType}
          onChange={(e) => handleVehicleTypeChange(e.target.value)}
          onBlur={() => handleBlur(setShowTypeDropdown)}
          required
        />
        {showTypeDropdown && (
          <div className={s.dropdown}>
            {filteredVehicleTypes.map((t) => (
              <p key={t} className={s.dropdownItem} onClick={() => selectVehicleType(t)}>
                {t}
              </p>
            ))}
          </div>
        )}
        </div>

        
        <div className={s.input_edit_wrapper}>
            <label className={s.label_add}>Пробег</label>
            <input className={s.input_add} type="text" value={mileage} onChange={(e) => setMileage(e.target.value)} required />
        </div>
      
        <div className={s.input_edit_wrapper}>
          <label className={s.label_add}>Цвет</label>
          <input className={s.input_add} type="text" value={color} onChange={(e) => setColor(e.target.value)} required />
        </div>

        {/* Дата приемки */}
        <div className={s.input_edit_wrapper}>
          <label className={s.label_add}>Дата приемки</label>
          <input className={s.input_add} type="date" value={dateAcceptance}  onChange={(e) => setDateAcceptance(e.target.value)} />
        </div>

        {error && <p className={s.error}>{error}</p>}
        {message && <p className={s.success}>{message}</p>}
        <div className={s.div_button}>
          <button className={s.add_submit_button} type="submit"   disabled={!isFormValid}>Добавить</button>  
        </div>
      </form>
      <div className={s.finish_div}>
      </div>
    </div>
  );
};


export default AddVehicle;
